/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cms_Fields_Faqsection_Title1Inputs */

const en_cms_fields_faqsection_title1 = /** @type {(inputs: Cms_Fields_Faqsection_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ section`)
};

/**
* | output |
* | --- |
* | "FAQ section" |
*
* @param {Cms_Fields_Faqsection_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cms_fields_faqsection_title1 = /** @type {((inputs?: Cms_Fields_Faqsection_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cms_Fields_Faqsection_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cms_fields_faqsection_title1(inputs)
});
export { cms_fields_faqsection_title1 as "cms_fields_faqSection_title" }